<template>
  <div class="author-Container">
    <div class="author-avatar">
      <v-avatar
        slot="icon"
        color="deep-purple accent-4"
        size="37"
        class="avatar"
        @click="isSinglePost"
      >
        <img
          :src="secureUrlAvatar() || require('@/assets/img/user-default.png')"
          :alt="author.name"
        />
      </v-avatar>
      <!-- <img class="flagIcon" v-if="author.language_flag" :src="getFlag()" /> -->
    </div>
    <div class="border-actions">
      <div class="nameText">
        <div class="authorText" @click="isSinglePost" :style="styles">
          {{ author.name }}
        </div>
        <div class="summaryText" @click="isSinglePost" :style="stylesSummary">
          {{ author.additional }}
        </div>
      </div>
      <div>
        <actions
          :keyPost="keyPost"
          :actionsItemData="actionsData"
          :actionsShare="actionsShare"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Actions from './actions'
import { RegisterEvent } from '@/analytics'
import { forceSSL, convertEmToPixels } from '@/helper/helper'

export default {
  name: 'Author',
  props: {
    actionsData: Object,
    actionsShare: Object,
    author: Object,
    keyPost: String,
    isSingle: Boolean
  },
  components: { Actions },
  data: () => ({}),
  computed: {
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    },
    stylesSummary () {
      const result = convertEmToPixels(14)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    isSinglePost () {
      return !this.isSingle ? this.goToAuthor() : null
    },
    goToAuthor () {
      RegisterEvent(
        'chi_author_selected',
        { target_id: this.author.name },
        'author_name'
      )
      return this.$router.push({
        name: 'Mixed',
        params: {
          name: this.author.name
        }
      })
    },
    getFlag () {
      const flag = this.author.language_flag.toLowerCase()
      return require(`@/assets/img/flags/${flag}.png`)
    },
    secureUrlAvatar () {
      return this.author.avatar && forceSSL(this.author.avatar)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/author.vue